import { useT } from '@/i18n';

// The four ways quotes reach the app, and when each key is worth configuring. Shown in the setup wizard and in
// Settings so the three key cards never look like three things the user must have: nothing is required.
const ROWS = ['builtin', 'finnhub', 'massive', 'twelvedata'] as const;

export function DataSources() {
  const { t } = useT();
  return (
    <div className="dsWrap">
      <table className="dsTable">
        <thead>
          <tr>
            <th>{t('ds.colSource')}</th>
            <th>{t('ds.colCost')}</th>
            <th>{t('ds.colGives')}</th>
            <th>{t('ds.colWhen')}</th>
          </tr>
        </thead>
        <tbody>
          {ROWS.map((r) => (
            <tr key={r}>
              <td className="dsName">{t(`ds.${r}.name` as const)}</td>
              <td className="dsCost">{t(`ds.${r}.cost` as const)}</td>
              <td>{t(`ds.${r}.gives` as const)}</td>
              <td className="muted">{t(`ds.${r}.when` as const)}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <p className="muted dsNote">{t('ds.note')}</p>
    </div>
  );
}
